import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { SECTION_NAMES } from '@constants/sectionNames'
import { Banner, Button, HeadContent, Icon, Loading } from '@fourthwall/components'
import { NewWindowIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import { AppsZapierSkeleton } from './AppsZapierSkeleton'
import ZapierConnectScreen from './assets/zapier_connect.png'
import { useZapier } from './hooks/useZapier'

export const AppsZapier = () => {
  const { connectBar, isLoading, status } = useZapier()

  if (!connectBar) {
    return <AppsZapierSkeleton />
  }

  return (
    <>
      <HeadContent title="Zapier" />
      <PageLayout size="tiny">
        <Dashboard.Section
          name="Zapier"
          topContent={<DashboardBackButton label={SECTION_NAMES.apps} to={routing.apps.self} />}
          bottomContent={
            <p>
              Connect your Fourthwall account to thousands of apps and automate your workflows.{' '}
              {/* <ButtonClean
                label="Learn more"
                withUnderline
                href={routing.external.helpCenter.zapier}
                target="_blank"
              /> */}
            </p>
          }
        >
          <Loading isLoading={isLoading}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <ConnectBar {...connectBar} />
              {status === 'NOT_CONNECTED' ? (
                <Banner appearance="info" title={<b>How to connect</b>}>
                  <div style={{ width: 300, height: 400, overflow: 'hidden' }}>
                    <img
                      src={ZapierConnectScreen}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                  <p>
                    From a Zapier zap, simply click the Account selector and create a new
                    connection.
                  </p>
                </Banner>
              ) : (
                <div style={{ padding: 16 }}>
                  <p>
                    <Button
                      appearance="primary"
                      label="Build your zap on Zapier"
                      icon={<Icon component={NewWindowIcon} height={16} width={16} />}
                      href={routing.external.zapier.createZap}
                      target="_blank"
                    />
                  </p>
                </div>
              )}
            </div>
          </Loading>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
